import api from 'services/api'
import {GET_ALL_TECHNICIANS_LIST} from '../endpoints'

export const getAllTechnicians = async () => await api.get(GET_ALL_TECHNICIANS_LIST)
